import React, { useCallback } from 'react'
import { Box } from '@mui/material'
import { AppButtonIcon } from '@components'
import { BACKEND_APIS } from '@constants'
import { useToast } from '@hooks'
import { postSubmit } from '@ui-seeker/utils'


export default function GroupedExportsTableToolbar({ selectedData, setSelectedRows }) {
	const { showToast } = useToast()

	const handleExportClick = useCallback(() => {
		const hasExportedFiles = selectedData.some(({ exported }) => exported)
		const exportIds = selectedData.filter(({ exported }) => !exported).map(({ id }) => id)
		if (hasExportedFiles) showToast.info('Only not exported files will be updated')

		if (exportIds.length > 0) {
			showToast.promise(postSubmit(`${BACKEND_APIS.INTERMEDIARY}/check/executions/export/group`, { id: exportIds }))
				.catch(() => {
					showToast.error('Error exporting files')
				})
				.finally(() => {
					setSelectedRows([])
				})
		} else {
			showToast.info('No available files were given')
		}

	}, [ selectedData ])

	return <Box>
		<AppButtonIcon
			icon="cloud-arrow-up"
			iconWeight="solid"
			sx={{ color: 'primary.main', mr: '1rem' }}
			tooltip="Force multiple file exports"
			onClick={handleExportClick}
		/>
	</Box>
}